import styled, { css } from 'styled-components'

import { theme } from '../../../theme'

import type { StyledPostfixProps, StyledTextInputProps } from './types'

export const TextInput = styled.input<StyledTextInputProps>`
  box-sizing: border-box;
  font-family: ${theme.fonts.mainFont};
  font-size: 16px;
  font-weight: normal;
  line-height: 1.2;
  color: ${({ readOnly }) =>
    readOnly ? theme.colors.slateGray : theme.colors.sapphireDark};
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.crystalBay};
  border-radius: 8px;
  padding: 14px;

  width: 100%;
  transition:
    border-color,
    ease 350ms;

  :focus {
    border-color: ${theme.colors.second};
  }

  :read-only {
    background: ${theme.colors.catskillWhite};
  }

  ::placeholder {
    color: ${theme.colors.blueAura};
  }

  :disabled {
    color: ${theme.colors.slateGray};
  }

  ${({ $error }) =>
    $error &&
    css`
      border-color: ${theme.colors.danger};
    `}

  ${({ $postfix }) =>
    $postfix &&
    css`
      padding-right: 24px;
    `}

  ${({ $noSpins }) =>
    $noSpins &&
    css`
      // Chrome, Safari, Edge, Opera
      ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      // Firefox
      -moz-appearance: textfield;
    `}


    ${({ $hideStepArrows }) =>
    $hideStepArrows &&
    css`
      &[type='number'] {
        -moz-appearance: textfield;
      }

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    `}
`

export const InputWrapper = styled.div`
  position: relative;
`

export const Postfix = styled.div<StyledPostfixProps>`
  color: ${({ $readOnly }) =>
    $readOnly ? theme.colors.slateGray : theme.colors.sapphireDark};
  font-family: ${theme.fonts.mainFont};
  font-weight: normal;
  position: absolute;
  right: 0;
  top: 0;
  padding: 12px;
  padding-left: 6px;
  font-size: 16px;
  display: block;
  height: 48px;
  ${({ isClickable }) => isClickable && 'cursor: pointer;'}
`

export const PasswordIcon = styled.div`
  position: absolute;
  line-height: 12px;
  right: 12px;
  top: 15px;
  cursor: pointer;
`
